import { Skeleton } from '@/components/ui/skeleton';

/**
 * Per-tab loading skeletons. Each matches the post-load layout of its tab so
 * data arrival causes no layout shift (DESIGN.md §15.1 / §15.6). Extends the
 * page-level ReportingSkeleton pattern.
 */

function CardBlock({ height = 'h-80' }: { height?: string }) {
  return <Skeleton className={`w-full rounded-lg ${height}`} />;
}

export function OverviewTabSkeleton() {
  return (
    <div className="space-y-6">
      {/* 6 scorecards */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-32 w-full rounded-lg" />
        ))}
      </div>
      {/* exception strip */}
      <CardBlock height="h-64" />
    </div>
  );
}

export function PerformanceTabSkeleton() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        <CardBlock />
        <CardBlock />
      </div>
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        <CardBlock />
        <CardBlock />
      </div>
      <CardBlock height="h-96" />
    </div>
  );
}

export function StockValueTabSkeleton() {
  return (
    <div className="space-y-6">
      {/* headline row */}
      <Skeleton className="h-24 w-full rounded-lg" />
      {/* breakdowns */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <CardBlock />
        <CardBlock />
        <CardBlock />
      </div>
      {/* top skus + aging */}
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        <CardBlock height="h-96" />
        <CardBlock height="h-96" />
      </div>
      {/* waterfall */}
      <CardBlock />
    </div>
  );
}
